module.exports = __webpack_public_path__ + "img/none.2db8d515.png";